<cpc-policy-card>
    <cpc-policy-card-header variant="secondary">
        <ng-container center>
            <p translate>{{'claim.azk-lob.' + claim.lobId}}</p>
            <h2>{{ claim.claimSubj }}</h2>
        </ng-container>
        <ng-container right>
            <cpc-badge size="medium" [rounded]="false" [bordered]="true">
                {{ claim.claimClassLabel | translate }}
            </cpc-badge>
        </ng-container>
    </cpc-policy-card-header>

    <cpc-policy-card-content [borderBottom]="false">
        <cpc-policy-card-entry align="space-between">
            <span title translate>claim.claim-number</span>
            <b>{{ claim.claimNumber }}</b>
        </cpc-policy-card-entry>
        <cpc-policy-card-entry align="space-between">
            <span title translate>claim.policy-number</span>
            <b>{{ claim.policyNumber }}</b>
        </cpc-policy-card-entry>
        <cpc-policy-card-entry align="space-between">
            <span title translate>claim.claim-date</span>
            <b>{{ claim.eventDate | dateFormat}}</b>
        </cpc-policy-card-entry>
        <cpc-policy-card-entry align="space-between">
            <span title translate>claim.notified</span>
            <b>{{ claim.reportDate | dateFormat}}</b>
        </cpc-policy-card-entry>

        <cpc-policy-card-entry align="space-between" *ngIf="claimState.name=='past'">
            <span title translate>claim.closed</span>
            <b>{{ claim.closeDate | dateFormat}}</b>
        </cpc-policy-card-entry>
        <cpc-policy-card-entry align="space-between" *ngIf="claimState.name=='past'">
            <span title translate>claim.outcome</span>
            <app-payment-status [premiumStatus]="claim.noPaymCloseFlg!=null?'claim_'+claim.noPaymCloseFlg:null">
            </app-payment-status>
        </cpc-policy-card-entry>
        <cpc-policy-card-entry align="space-between" *ngIf="claimState.name=='past'">
            <span title translate>claim.paid-amount</span>
            <b>{{ claim.paymentAmountSum | stringFormat | currencyFormat}}</b>
        </cpc-policy-card-entry>


        <cpc-policy-card-entry align="space-between" *ngIf="claimState.name=='past' && claim.ratingLiq != null">
            <span title translate>claim.feedback</span>
            <cpc-star-rating [value]="claim.ratingLiq"></cpc-star-rating>
        </cpc-policy-card-entry>
        <cpc-policy-card-entry align="space-between"
            *ngIf="claimState.name=='past' && claim.ratingLiq == null && claim.rateUrl != null">
            <div class="cpc-policy-card-entry_title"></div>
            <div class="cpc-policy-card-entry_center"></div>
            <div class="cpc-policy-card-entry_content">
                <nx-link>
                    <a href="{{ claim.rateUrl }}">
                        <span translate>claim.feedbackBtn</span>
                        <nx-icon name="launch" class="nx-margin-left-2xs"></nx-icon>
                    </a>
                </nx-link>
            </div>
        </cpc-policy-card-entry>


    </cpc-policy-card-content>

    <cpc-policy-card-footer [borderTop]="claimState.name=='past'&&claim.documents.length>0?true:false">

        <cpc-policy-card-entry align="space-between" footer
            *ngIf="claimState.name!=='past'&&claim.claimTrackLink!==null">
            <a href="{{claim.claimTrackLink}}" target="_blank">
                <cpc-button size="x-small" [noHorizontalMargin]="true" [noVerticalMargin]="true"><span
                        translate>claim.track-your-claim</span>
                </cpc-button>
            </a>
        </cpc-policy-card-entry>

        <cpc-policy-card-entry overflowContent="visible" align="space-between"
            *ngIf="claimState.name=='past'&&claim.documents.length>0">
            <div class="cpc-policy-card-entry_title"></div>
            <div class="cpc-policy-card-entry_center"></div>
            <div class="cpc-policy-card-entry_content">
                <cpc-button size="x-small" mode="tertiary" (click)="drawerOpenModel=!drawerOpenModel"
                    [noHorizontalMargin]="true" [noVerticalMargin]="true">
                    <span style="padding-right: 6px" translate>claim.showDocuments</span>
                    <cpc-icon *ngIf="!drawerOpenModel" icon="chevron-down"></cpc-icon>
                    <cpc-icon *ngIf="drawerOpenModel" icon="chevron-up"></cpc-icon>
                    <cpc-dropdown-drawer [drawerOpenModel]="drawerOpenModel" [isMobileBorder]="true">
                        <ng-template ngFor let-document="$implicit" [ngForOf]="claim.documents">
                            <a href="{{ downLoadDocumentUrl + document.itemId }}" target="_blank">
                                <cpc-button mode="tertiary" size="x-small"
                                    (click)="drawerOpenModel=false;clickedItem=true">
                                    <cpc-icon icon="download" iconSet="ndbx" style="padding-right: 6px"></cpc-icon>
                                    <span style="text-align: left">{{ document.subclassidLabel }}</span>
                                </cpc-button>
                            </a>
                        </ng-template>
                    </cpc-dropdown-drawer>
                </cpc-button>
            </div>
        </cpc-policy-card-entry>

    </cpc-policy-card-footer>

</cpc-policy-card>
